import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {SellerRepositoriesFactory} from '../Repositories/factory.js'
import {UpdateInstantOfferSellerRequest} from '../Requests/UpdateInstantOfferSellerRequest.js'

class UpdateInstantOfferSellerUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create({config}) {
    return new UpdateInstantOfferSellerUseCase({
      repository: SellerRepositoriesFactory.hTTPSellerRepository({config})
    })
  }

  @tracer({metric: 'UpdateInstantOfferSellerUseCase#execute'})
  @inlineError
  async execute({instantOfferId, licensePlate, condition, zipCode} = {}) {
    const updateInstantOfferRequest = UpdateInstantOfferSellerRequest.create({
      licensePlate,
      condition,
      zipCode
    })

    const [error, instantOfferDetailsVO] = await this.#repository.updateInstantOffer({
      instantOfferId,
      updateInstantOfferRequest
    })

    if (error) return Promise.reject(error)

    return instantOfferDetailsVO.toJSON()
  }
}

export const factory = UpdateInstantOfferSellerUseCase.create
